<template>
  <div>
    <v-card
      class="mx-auto pa-1  rounded-lg mb-2 elevation-2"
      min-height="17vh"
      tile
    >
      <v-row no-gutters>
        <v-col cols="12">
          <div class="d-flex justify-space-between">
            <span class="text-body-2 font-weight-bold ml-1">
              {{ item.Codigo }}
            </span>
            <v-btn
              @click="VerificaPedido(item)"
              class="mx-1"
              x-small
              depressed
              color="error"
            >
              <v-icon left> mdi-delete-forever </v-icon>
              Eliminar</v-btn
            >
          </div>
        </v-col>
        <v-col cols="3">
          <div
            class="ribbonpromo"
            v-if="item.IndPromo"
            transition="slide-x-transition"
          >
            ¡EN PROMOCIÓN!
          </div>
          <div class="d-flex justify-center aling-center">
            <v-avatar tile class="img_art" size="100">
              <imgPredet
                :withImg="150"
                :codart="item.Codigo"
                :urlimg="imgSrc(item.Codigo)"
                :key="updateImg"
              />
            </v-avatar>
          </div>
        </v-col>
        <v-col cols="9">
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold body-2">
                {{ item.Nombre }}</v-list-item-title
              >

              <v-list-item-subtitle class="font-weight-medium body-2">
                Precio Unitario: {{ simboloMoneda[tipoMoneda] }}
                {{ item.Precio[tipoMoneda] | numeral("0,0.00") }}
              </v-list-item-subtitle>
              <v-list-item-subtitle
                class="font-weight-medium body-2"
                v-if="item.Descuento !== 0"
              >
                Descuento: {{ item.Descuento | numeral("0,0") }} %
              </v-list-item-subtitle>
              <v-list-item-subtitle class="font-weight-medium body-2">
                Precio Neto: {{ simboloMoneda[tipoMoneda] }}
                {{ item.PrecioNeto[tipoMoneda] | numeral("0,0.00") }}
              </v-list-item-subtitle>
              <!-- por ahora solo muestra promocion unidades, falta implementar paquetes y combos -->
              <v-list-item-subtitle
                class="font-weight-medium body-2"
                v-if="item.Promo !== 0"
              >
                <strong> {{ `Promo: ` }}</strong
                >{{ item.Promo }} - {{ item.Tipo }} Min:
                {{ item.CantidadMin }} Und
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>

        <v-col cols="12">
          <div class="d-flex justify-space-between">
            <div class="d-flex flex-column ml-2">
              <span class="text-body-2"> Precio Total </span>
              <span class="text-body-2 font-weight-bold">
                {{ simboloMoneda[tipoMoneda] }}
                {{ item.PrecioTot[tipoMoneda] | numeral("0,0.00") }}
              </span>
            </div>
            <div class="d-flex flex-row my-div mr-2">
              <div>
      
                <v-btn
                  @click="decrementar"
                  icon
                  text
                  class="text-right"
                  color="primary"
                >
                  <v-icon size="35">mdi-minus</v-icon>
                </v-btn>
              </div>
              <div class="d-flex flex-column">
                <v-text-field
                  dense
                  filled
                  hide-details
                  :label="`${formatNumber(
                    contCantidad({
                      contmayor: item.ContentMayor,
                      cant: cantidadEntera,
                    })
                  )} ${item.UniVenta}`"
                  type="number"
                  :rules="[reglaSoloEnteros]"
                  :min="1"
                  :max="disponibleMayor({ item })"
                  style="width: 100px; font-size: 1.1rem"
                  reverse
                  v-model="cantidadEntera"
                  @change="
                    item.CantCar < 1
                      ? (item.CantCar = item.ContentMayor)
                      : (item.CantCar = item.CantCar);
                    CalculaItem;
                  "
                  @input="
                    item.CantCar < 1
                      ? (item.CantCar = item.ContentMayor)
                      : (item.CantCar = item.CantCar);
                    CalculaItem;
                  "
                ></v-text-field>
                <v-btn
                  v-if="item.CantCmb"
                  x-small
                  color="green darken-1"
                  dark
                  @click="CargarItem(item)"
                >
                  Actualizar
                </v-btn>
              </div>
              <div>
                <v-btn
                 @click="incrementar"
                  icon
                  text
                  class="mr-1"
                  color="primary"
                >
                  <v-icon size="35">mdi-plus</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <v-dialog v-model="dialogEliminar.dialog" width="380" persistent>
      <v-card class="elevation-12" color="warning" dark>
        <v-toolbar light flat color="white">
          <v-toolbar-title :class="['d-none', 'd-sm-none', 'd-md-flex']">
            <v-img
              contain
              :src="`${domoapi2_img}Cia/15/logo?archivo=1.png`"
              id="Home"
              width="154"
            ></v-img>
          </v-toolbar-title>

          <v-container>
            <v-layout row>
              <v-toolbar-title :class="['mx-auto']"
                >Eliminar Artículo</v-toolbar-title
              >
            </v-layout>
          </v-container>
          <v-btn
            icon
            @click="
              dialogEliminar = {
                dialog: false,
                articulo: {},
                info: [],
              }
            "
          >
            <v-icon color="primary">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text :class="['text-subtitle-2']">
          ¿ Desea eliminar el articulo ?
          <br />
          {{ dialogEliminar.articulo.Codigo }}
          <br />
          {{ dialogEliminar.articulo.Nombre }}
        </v-card-text>

        <v-card-text v-if="dialogEliminar.info.length !== 0">
          Los siguientes artículos van a cambiar en su promoción si continua:
          <ul>
            <li v-for="(info, index) in dialogEliminar.info" :key="index">
              {{ info }}
            </li>
          </ul>
        </v-card-text>

        <v-divider color="#D3BC8D"></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            text
            class="mr-3"
            outlined
            elevation="0"
            @click="
              dialogEliminar = {
                dialog: false,
                articulo: {},
                info: '',
              };
              get_ConsultaPedido();
            "
          >
            No
          </v-btn>
          <v-btn
            color="primary"
            elevation="0"
            @click="
              dialogEliminar = {
                dialog: false,
                articulo: {},
                info: '',
              };
              EliminaItem(item.Codigo);
            "
          >
            Si
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import imgPredet from "@/components/ImgPred";
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";

export default {
  props: {
    item: Object,
  },
  components: {
    imgPredet,
  },
  data() {
    return {
      count: 1,
      imgP: false,
      numeroEntero: "",
      error: false,
      datosPromo: [],
      dialogEliminar: {
        dialog: false,
        articulo: {},
        info: "",
      },
      updateImg: Math.floor(Math.random() * 100),
    };
  },
  computed: {
    ...mapState([
      "Pedido",
      "tipoMoneda",
      "simboloMoneda",
      "imgPeque",
      "NoImg",
      "loading",
      "domoapi2_img",
      "dataUser",
    ]),
    ...mapGetters(["filterpromo"]),
    contenidoMayor: function () {
      return function ({ item }) {
        const ruta = this.$route.name;
        const itemContenido = ruta === "Detalle" ? `DisponNum` : `Disponible`;
        const { [itemContenido]: Disponible, EnTransito, ContentMayor } = item;
        if (this.dataUser.TipoUsuario === "U") return 100;
        else
          return ContentMayor !== 0
            ? item.Stock + Math.trunc(EnTransito / ContentMayor)
            : null;
      };
    },
    contCantidad: function () {
      return function ({ contmayor, cant }) {
        // return this.validaContenido ? contmayor * cant : cant;
        return contmayor * cant;
      };
    },

    disponibleMayor: function () {
      return function ({ item: { Disponible, ContentMayor, Stock } }) {
        return ContentMayor !== 0 ? Stock : null;
      };
    },
    cantidadEntera: {
      get() {
        return Math.trunc(this.item.CantCar / this.item.ContentMayor);
      },

      set(valor) {
        this.item.CantCar = valor * this.item.ContentMayor;
      },
    },
    CalculaItemCar() {
      // let ItemCar = this.item
      let ItemsPedido = this.Pedido.items;
      let Promociones = this.obtenerPromociones({
        ItemsPedido,
        ItemCar: this.item,
      });

      let PromoAct = this.obtenerPromocionActiva({
        Promociones,
        ItemCar: this.item,
      });
   
    },
    ValidaCantidadPromo: function () {
      return function ({ item }) {
        const { IndPromo, Codigo, CantCar } = item;

        let p = [];
        let indexPromo = [];
        if (IndPromo) {
          p = this.Pedido.promocion.filter((x) => {
            return x["Articulo"] === Codigo && CantCar >= x["Cantidad"];
          });
          p.forEach((x) => {
            indexPromo.push(x["Cantidad"]);
          });
        } //si hay promo
        else {
          //no hay promo
        }

        if (p.length > 0) {
          let xindexPromo = indexPromo.reduce(function (prev, curr) {
            return Math.abs(curr - CantCar) < Math.abs(prev - CantCar)
              ? curr
              : prev;
          });
          let findexPromo = indexPromo.findIndex((x) => xindexPromo === x);
          this.datosPromo = p[findexPromo];

          this.item.Promo = this.datosPromo.Promo;
          this.item.CantidadMin = this.datosPromo.min;
          this.item.TipoPromo = this.datosPromo.Tipo;
          this.item.Descuento = this.datosPromo.descuento;
          this.item.CantCmb =
            this.item.CantCar !== this.item.Cantidad ? true : false;
          //this.CalculaPrecio()
          /* this.set_AdPromoT();
        this.$emit("promoArticulo", p, CantCar, true, Codigo); */
          return true;
        } else {
          this.datosPromo = [];
          /*  this.set_AdPromoF();
        this.$emit("promoArticulo", [], CantCar, false, null); */
          return false;
        }
      };
    },

    obtenerPromocionActiva: function () {
      return function ({ Promociones, ItemCar }) {
      
        let PromoAct = {},
          PromoRangos = [
            {
              Articulo: ItemCar.Codigo,
              Codigo: 0,
              Tipo: "",
              PrecioNeto: ItemCar.PrecioNeto,
              descuento: 0,
              CantCar: 0,
              min: ItemCar.Contenido,
              max: ItemCar.Contenido,
              pos: 0,
            },
          ];
        const { PromoDisp, Promos, ComboEsp } = Promociones;
        if (PromoDisp) {
          let i = 0;
          let Articulo = ItemCar.Codigo;
          Promos.forEach((p) => {
            if (
              Object.entries(p.Articulos.filter((f) => f === Articulo))
                .length !== 0
            ) {
              PromoRangos.push({
                Articulo,
                Codigo: p.Codigo,
                Tipo: p.Tipo,
                descuento: p.Descuento,
                CantCar: p.CantCar,
                min: p.Cantidad,
                max: p.Cantidad,
                pos: i,
              });
              PromoRangos[i].max = p.Cantidad;
              i++;
            }
          });
        }
        PromoAct = PromoRangos.filter((f) =>
          f.min !== f.max && f.CantCar > 0
            ? f.CantCar >= f.min && f.CantCar < f.max
            : f.CantCar >= f.min
        )[0];
        if (!PromoAct) {
          PromoAct = PromoRangos.filter((f) =>
            f.min !== f.max
              ? this.item.CantCar >= f.min && this.item.CantCar < f.max
              : this.item.CantCar >= f.min
          )[0];
        }
        return PromoAct;
      };
    },
    aplicarDescuentos: function () {
      return function ({ ItemCar, PromoAct }) {
        // Code
      };
    },
    obtenerPromociones: function () {
      return function ({ ItemsPedido, ItemCar }) {
        let Promos = [],
          PromoDisp = false,
          ComboEsp = false;
        ItemsPedido.forEach((itm) => {
          itm.Promociones.forEach((prom) => {
          
            if (prom.Articulo === ItemCar.Codigo) {
              PromoDisp = true;

              if (prom.TipoPromo === "Combo Especial") {
                ComboEsp = true;
            
              }
            }
            if (Promos[prom.Codigo]) {
              Promos[prom.Codigo].Codigo = prom.Codigo;
              Promos[prom.Codigo].Articulos.push(prom.Articulo);
              Promos[prom.Codigo].Tipo = prom.TipoPromo;
              Promos[prom.Codigo].Descuento = prom.Descuento;
              Promos[prom.Codigo].Cantidad = prom.Cantidad;
              Promos[prom.Codigo].CantCar += itm.CantCar;
            } else {
              Promos[prom.Codigo] = {
                Codigo: prom.Codigo,
                Articulos: [prom.Articulo],
                Tipo: prom.Tipo,
                Descuento: prom.Descuento,
                Cantidad: prom.Cantidad,
                CantCar: itm.CantCar,
              };
            }
          });
        });
        return { PromoDisp, Promos, ComboEsp };
      };
    },

    CalculaItem() {
      let ItemCar = this.item,
        Promociones = ItemCar.Promociones,
        PromoAct = {},
        PromoRangos = [
          {
            Articulo: ItemCar.Codigo,
            Codigo: 0,
            Tipo: "",
            PrecioNeto: ItemCar.PrecioNeto,
            descuento: 0,
            CantCar: 0,
            min: ItemCar.ContentMayor,
            max: ItemCar.ContentMayor,
            pos: 0,
          },
        ],
        Promos = [],
        PromoDisp = false,
        ComboEsp = false,
        ComboArt = [];

      this.Pedido.items.forEach((itm) => {
        itm.Promociones.forEach((prom) => {
          if (prom.Articulo === ItemCar.Codigo) {
            PromoDisp = true;
            if (prom.TipoPromo === "Combo Especial") {
              ComboEsp = true;
            }
          }

          if (PromoDisp) {
            if (Promos[prom.Codigo]) {
              Promos[prom.Codigo].Codigo = prom.Codigo;
              Promos[prom.Codigo].Articulos.push(prom.Articulo);
              Promos[prom.Codigo].Tipo = prom.TipoPromo;
              Promos[prom.Codigo].Descuento = prom.Descuento;
              Promos[prom.Codigo].Cantidad = prom.Cantidad * itm.ContentMayor;
              Promos[prom.Codigo].CantCar += itm.CantCar;
            } else {
              Promos[prom.Codigo] = {
                Codigo: prom.Codigo,
                Articulos: [prom.Articulo],
                Tipo: prom.TipoPromo,
                Descuento: prom.Descuento,
                Cantidad: prom.Cantidad * itm.ContentMayor,
                CantCar: itm.CantCar,
              };
            }
          }
        });
      });

      this.item.PrecioNeto = [
        this.item.Precio[0] - this.item.Precio[0] * (this.item.Descuento / 100),
        this.item.Precio[1] - this.item.Precio[1] * (this.item.Descuento / 100),
      ];
      this.item.PrecioTot = [
        this.item.PrecioNeto[0] * this.item.CantCar,
        this.item.PrecioNeto[1] * this.item.CantCar,
      ];

      if (PromoDisp) {
        let i = 0;
        const Articulo = ItemCar.Codigo;
        Promos.forEach((p) => {
          if (
            Object.entries(p.Articulos.filter((f) => f === Articulo)).length !==
            0
          ) {
            PromoRangos.push({
              Articulo: Articulo,
              Codigo: p.Codigo,
              Tipo: p.Tipo,
              descuento: p.Descuento,
              CantCar: p.CantCar,
              min: p.Cantidad,
              max: p.Cantidad,
              pos: i,
            });
            PromoRangos[i].max = p.Cantidad;
            i++;
          }
        });
      }

      PromoAct = PromoRangos.filter((f) =>
        f.min !== f.max && f.CantCar > 0
          ? f.CantCar >= f.min && f.CantCar < f.max
          : f.CantCar >= f.min
      )[0];

      if (!PromoAct) {
        PromoAct = PromoRangos.filter((f) =>
          f.min !== f.max
            ? this.item.CantCar >= f.min && this.item.CantCar < f.max
            : this.item.CantCar >= f.min
        )[0];
      }

      if (ComboEsp) {
   
        ComboArt = Promos[Promociones[0].Codigo]
          ? Promos[Promociones[0].Codigo].Articulos
          : [ItemCar.Codigo];

        this.Pedido.items.forEach((itm) => {
          if (
            Object.entries(ComboArt.filter((f) => f === itm.Codigo)).length !==
              0 &&
            !!PromoAct
          ) {
            itm.CantCmb = false;
            itm.Promo = PromoAct.Codigo;
            itm.CantidadMin = PromoAct.min;
            itm.TipoPromo = PromoAct.Tipo;
            itm.Descuento = PromoAct.descuento;
            itm.PrecioNeto = [
              itm.Precio[0] - itm.Precio[0] * (itm.Descuento / 100),
              itm.Precio[1] - itm.Precio[1] * (itm.Descuento / 100),
            ];
            itm.PrecioTot = [
              itm.PrecioNeto[0] * itm.CantCar,
              itm.PrecioNeto[1] * itm.CantCar,
            ];
            itm.MontoIVA = [
              itm.PrecioTot[0] * itm.PorcentIva,
              itm.PrecioTot[1] * itm.PorcentIva,
            ];
            itm.CantCmb =
              itm.CantCar !== itm.Cantidad ||
              itm.Descuento !== PromoAct.Descuento
                ? true
                : false;
          }
        });
      } else {
        this.item.Promo = PromoAct.Codigo;
        this.item.CantidadMin = PromoAct.min;
        this.item.TipoPromo = PromoAct.Tipo;
        this.item.Descuento = PromoAct.descuento;
        this.item.PrecioNeto = [
          this.item.Precio[0] -
            this.item.Precio[0] * (this.item.Descuento / 100),
          this.item.Precio[1] -
            this.item.Precio[1] * (this.item.Descuento / 100),
        ];
        this.item.PrecioTot = [
          this.item.PrecioNeto[0] * this.item.CantCar,
          this.item.PrecioNeto[1] * this.item.CantCar,
        ];
        this.item.MontoIVA = [
          this.item.PrecioTot[0] * this.item.PorcentIva,
          this.item.PrecioTot[1] * this.item.PorcentIva,
        ];
        this.item.CantCmb =
          this.item.CantCar !== this.item.Cantidad ? true : false;
      }

      this.get_calculaCarrito();

      return this.item;
    },
    imgSrc() {
      return function (id) {
        let xSrc = this.domoapi2_img;
        xSrc += "Articulo/";
        xSrc += this.ChrEsp(id);
        xSrc += "/Principal?";
        xSrc += "Cia=15";
        return xSrc;
      };
    },
  },
  methods: {
    ...mapMutations([
      "CLR_PROMO",
      "CLR_DATOS_ART",
      "set_mensaje",
      "set_AdPromoF",
      "set_AdPromoT",
    ]),
    ...mapActions([
      "cargarDatosPromo",
      "get_ConsultaPedido",
      "set_updateArtCarrito",
      "set_eliminaArtCarrito",
      "get_calculaCarrito",
    ]),
    incrementar() {
     
      this.cantidadEntera++;
      this.CalculaItem;
    },
    decrementar() {
   
     
      if (this.cantidadEntera > 1) {
        this.cantidadEntera--;
        this.CalculaItem;
      }
    },
    reglaSoloEnteros(valor) {
      const esValido = !valor || /^\d+$/.test(valor);
      this.error = !esValido; // Actualiza la variable error según la validación
      return esValido || "Solo Enteros";
    },
    isNumber: function (evt) {
      let charCode = evt.which ? evt.which : evt.keyCode;
      let inputElement = evt.target;
      let currentValue = inputElement.value;
      let newValue = parseFloat(currentValue + String.fromCharCode(charCode));
      let isMaximo = newValue > this.contenidoMayor({ item: this.item });
      if (
        (charCode > 31 && (charCode < 48 || charCode > 57)) ||
        (isMaximo && charCode != 9)
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    formatNumber(num) {
      return parseFloat(num).toFixed(2);
    },
    articuloRoute(codart) {
      this.CLR_PROMO();
      this.CLR_DATOS_ART();
      this.cargarDatosPromo({ codart: codart });
      codart = encodeURIComponent(codart);
      this.$vuetify.goTo(0);
      return this.$router.push("/articulo/" + codart);
    },
    CalculaPrecio() {
      this.item.PrecioNeto = [
        this.item.Precio[0] - this.item.Precio[0] * (this.item.Descuento / 100),
        this.item.Precio[1] - this.item.Precio[1] * (this.item.Descuento / 100),
      ];
      this.item.PrecioTot = [
        this.item.PrecioNeto[0] * this.item.CantCar,
        this.item.PrecioNeto[1] * this.item.CantCar,
      ];
    },

    async CargarItem(xitem) {
      let Arts = "",
        Cants = "",
        Proms = "";
      await this.Pedido.items.forEach(async (itm) => {
        if (itm.CantCmb) {
          if (Arts === "" && Cants === "") {
            Arts = `${itm.Codigo}`;
            Cants = `${itm.CantCar}`;
            Proms = `${itm.Promo}`;
          } else {
            Arts += `,${itm.Codigo}`;
            Cants += `,${itm.CantCar}`;
            Proms += `,${itm.Promo}`;
          }
        }
      });
      if (Arts === "" && Cants === "" && Proms === "") {
        Arts = xitem.Codigo;
        Cants = xitem.CantCar;
        Proms = this.Promo;
      }
      await this.set_updateArtCarrito({
        articulo: Arts,
        cantidad: Cants,
        promo: Proms,
      });
      this.set_mensaje({
        Visible: true,
        Msj: "Articulo Actuaizado",
        Type: "success",
      });
    },
    async EliminaItem(xcod) {
      let Arts = "",
        Cants = "",
        Proms = "";

      await this.Pedido.items.forEach(async (itm) => {
        if (itm.CantCmb) {
          if (Arts === "" && Cants === "") {
            Arts = `${itm.Codigo}`;
            Cants = `${itm.CantCar}`;
            Proms = `${itm.Promo}`;
          } else {
            Arts += `,${itm.Codigo}`;
            Cants += `,${itm.CantCar}`;
            Proms += `,${itm.Promo}`;
          }
        }
      });

      await this.set_eliminaArtCarrito({
        articulo: xcod,
      });

      if (Arts !== "" && Cants !== "" && Proms !== "") {
        await this.set_updateArtCarrito({
          articulo: Arts,
          cantidad: Cants,
          promo: Proms,
        });
      }
      this.set_mensaje({
        Visible: true,
        Msj: "Articulo Eliminado",
        Type: "success",
      });
      await this.get_ConsultaPedido();
    },
    async VerificaPedido(vItem) {
      let PromoAct = {},
        PromoRangos = [
          {
            Codigo: 0,
            Tipo: "",
            descuento: 0,
            CantCar: 0,
            min: vItem.ContentMayor,
            max: vItem.ContentMayor,
            pos: 0,
          },
        ],
        Promos = [],
        xInfo = [];

      if (vItem.Tipo === "Combo Especial") {
        this.Pedido.items.forEach((itm) => {
          itm.Promociones.forEach((prom) => {
            if (prom.TipoPromo === vItem.Tipo) {
              if (Promos[prom.Codigo]) {
                Promos[prom.Codigo].Codigo = prom.Codigo;
                Promos[prom.Codigo].Articulos.push(prom.Articulo);
                Promos[prom.Codigo].Tipo = prom.TipoPromo;
                Promos[prom.Codigo].Descuento = prom.Descuento;
                Promos[prom.Codigo].Cantidad = prom.Cantidad;
                Promos[prom.Codigo].CantCar +=
                  prom.Articulo !== vItem.Codigo ? itm.CantCar : 0;
              } else {
                Promos[prom.Codigo] = {
                  Codigo: prom.Codigo,
                  Articulos: [prom.Articulo],
                  Tipo: prom.TipoPromo,
                  Descuento: prom.Descuento,
                  Cantidad: prom.Cantidad,
                  CantCar: prom.Articulo !== vItem.Codigo ? itm.CantCar : 0,
                };
              }
            }
          });
        });

        let i = 0;

        Promos.forEach((p) => {
          if (
            Object.entries(p.Articulos.filter((f) => f === vItem.Codigo))
              .length !== 0
          ) {
            PromoRangos.push({
              Codigo: p.Codigo,
              Tipo: p.Tipo,
              descuento: p.Descuento,
              CantCar: p.CantCar,
              min: p.Cantidad * vItem.ContentMayor,
              max: p.Cantidad * vItem.ContentMayor,
              pos: i,
            });
            PromoRangos[i].max = p.Cantidad * vItem.ContentMayor;
            i++;
          }
        });
      }

      PromoRangos.forEach((x) => {

        if (x.CantCar === 0) {
          PromoAct = x;
        } else if (x.CantCar >= x.min && x.CantCar < x.max) {
          PromoAct = x;
        } else if (x.CantCar >= x.min) {
          PromoAct = x;
        }
  
      });

      

      this.Pedido.items.forEach((itm) => {
        if (
          itm.Codigo !== vItem.Codigo &&
          itm.Promo === vItem.Promo &&
          vItem.Tipo === "Combo Especial"
        ) {
          //(PromoAct.Codigo)
          itm.Promo = PromoAct.Codigo;
          itm.CantCmb = true;
          xInfo.push(itm.Codigo);
        }
      });

      this.dialogEliminar = {
        dialog: true,
        articulo: this.item,
        info: xInfo,
      };
    },
    ChrEsp(chr) {
      const chrSplit = chr.split("");
      let newChr = "";

      chrSplit.forEach((x) => {
        if (x === "/") newChr += "-";
        else if (x === ".") newChr += "-";
        else newChr += x;
      });

      return newChr;
    },
  },
};
</script>

<style scoped>
.v-cardgrid {
  background-color: #ffffff !important;

  border: 1px solid #b05954 !important;

  transition: opacity 0.4s ease-in-out;
  margin: 1px;
}
.ribbonpromo {
  z-index: 1;
  position: absolute;
  top: 25px;
  left: 15px;
  width: 95px;
  display: block;
  padding: 1px;
  font-size: 10px;
  border-radius: 5px;
  background-color: #d3bc8d;
  color: #7c2629;
  text-align: center;
  border-left: 2px solid #b05954 !important;
  border-top: 2px solid #b05954 !important;
}
@media (max-width: 960px) {
  .ribbonpromo {
    left: 10px;
    width: 100px;
  }
}
</style>
